import { MouseEvent } from "react";
import { ConfirmModal } from "../types";

export default function DeleteModal({ modal, onConfirm, onCancel }: {
    modal: ConfirmModal; onConfirm: () => void; onCancel: () => void;
}) {
    if (!modal.open) return null;
    return (
        <div style={{
            position: "fixed", inset: 0, zIndex: 500,
            background: "rgba(0,0,0,0.65)", backdropFilter: "blur(4px)",
            display: "flex", alignItems: "center", justifyContent: "center",
        }} onClick={onCancel}>
            <div onClick={(e: MouseEvent<HTMLDivElement>) => e.stopPropagation()} style={{
                background: "#1a1917", border: "1px solid rgba(255,255,255,0.1)",
                borderRadius: 16, padding: 28, width: 380, maxWidth: "90vw",
                animation: "modalIn 0.2s ease",
            }}>
                <div style={{
                    width: 44, height: 44, borderRadius: "50%", background: "rgba(224,82,82,0.12)",
                    border: "1px solid rgba(224,82,82,0.25)", display: "flex", alignItems: "center",
                    justifyContent: "center", fontSize: 20, marginBottom: 16,
                }}>🗑</div>
                <div style={{ fontSize: 15, fontWeight: 600, color: "var(--text)", marginBottom: 8 }}>Delete certification?</div>
                <div style={{ fontSize: 14, color: "var(--text3)", lineHeight: 1.6, marginBottom: 24 }}>
                    <strong style={{ color: "var(--text2)" }}>{modal.title}</strong> will be permanently removed. This cannot be undone.
                </div>
                <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
                    <button onClick={onCancel} style={{
                        padding: "9px 18px", borderRadius: 8, border: "1px solid var(--border)",
                        background: "transparent", color: "var(--text2)", fontSize: 14, cursor: "pointer",
                        fontFamily: "'DM Sans',sans-serif",
                    }}>Cancel</button>
                    <button onClick={onConfirm} style={{
                        padding: "9px 18px", borderRadius: 8, border: "1px solid rgba(224,82,82,0.35)",
                        background: "rgba(224,82,82,0.12)", color: "#e05252", fontSize: 14,
                        fontWeight: 500, cursor: "pointer", fontFamily: "'DM Sans',sans-serif",
                    }}>Delete</button>
                </div>
            </div>
        </div>
    );
}
